import React from 'react';

import {FillDirection} from 'lookup-config/LookupConfigModalConstants';
import {getFillDirectionIconName, getFillDirectionText} from 'samples/grids/GridUtil';
import ModalButtonKey from 'test/lib/cypress/shared/ModalButtonKey';
import {ButtonSize} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';
import ToggleGroup from 'ui-library/ToggleGroup';

export interface FillDirectionModalProps {
  gridTypeName: string;
  onRequestClose: () => void;
  onSubmit: (fillDirection: FillDirection) => void;
}
export default function FillDirectionModal(props: FillDirectionModalProps): JSX.Element {
  const [fillDirection, setFillDirection] = React.useState<FillDirection>(FillDirection.ACROSS_ROWS);
  return (
    <Modal
      title={`Fill ${props.gridTypeName} with scanner`}
      onRequestClose={props.onRequestClose}
      onRequestSubmit={() => {
        props.onSubmit(fillDirection);
      }}
      buttons={[
        {text: 'Cancel', cancel: true},
        {
          text: 'Start scanning',
          submit: true,
          dataTestAttrs: {
            component: 'FillDirectionModal',
            element: 'button',
            key: ModalButtonKey.SUBMIT,
          },
        },
      ]}
      closeable={true}
      medium={true}
    >
      <div className="u-padding-bottom u-base-text"> Choose a fill direction: </div>
      <ToggleGroup
        onChangeSelection={(selection) => {
          setFillDirection(selection);
        }}
        selection={fillDirection}
        size={ButtonSize.MEDIUM}
        options={[
          {
            id: FillDirection.ACROSS_ROWS,
            buttonProps: {
              text: getFillDirectionText(FillDirection.ACROSS_ROWS),
              icon: getFillDirectionIconName(FillDirection.ACROSS_ROWS),
            },
          },
          {
            id: FillDirection.DOWN_COLUMNS,
            buttonProps: {
              text: getFillDirectionText(FillDirection.DOWN_COLUMNS),
              icon: getFillDirectionIconName(FillDirection.DOWN_COLUMNS),
            },
          },
        ]}
        isFullWidth={true}
      />
    </Modal>
  );
}
